import React from 'react';

const WelcomeSection = () => {
  const groupName = localStorage.getItem("group_name");

  return (
    
      <h1 className="text-2xl font-semibold tracking-tight text-brand-950">
        {groupName}
      </h1>
  );
};

export default WelcomeSection;
